import { createNewTheme, createNewThemeOverride } from './theme';
import { mockedDefaultActivityThemeStyles } from './theme-implementation';

type CSSVarFunction = `var(--mantine-${string})`;

type NestedCSSVars<T> = {
  [K in keyof T]: T[K] extends object ? NestedCSSVars<T[K]> : CSSVarFunction;
};

const createNestedVars = <T extends Record<string, any>>(obj: T, prefix: string[] = ['mantine']): NestedCSSVars<T> => {
  const result: any = {};

  for (const key in obj) {
    let newPrefix = [...prefix];

    if (key === 'white' || key === 'black') {
      newPrefix = ['mantine', 'color', key];
    } else if (key === 'colors') {
      newPrefix = ['mantine', 'color'];
    } else if (prefix[prefix.length - 1] === 'system-dark') {
      newPrefix[newPrefix.length - 1] = 'systemDark';
      newPrefix.push(key.replace(/([A-Z])/g, '-$1').toLowerCase());
    } else {
      newPrefix.push(key.replace(/([A-Z])/g, '-$1').toLowerCase());
    }

    if (typeof obj[key] === 'object' && obj[key] !== null) {
      result[key] = createNestedVars(obj[key], newPrefix);
    } else {
      result[key] = `var(--${newPrefix.join('-')})` as CSSVarFunction;
    }
  }

  return result as NestedCSSVars<T>;
};

// Vars only use keys from the theme so it is safe to use any theme that fits our interface
const mockedThemeOverride = createNewThemeOverride(mockedDefaultActivityThemeStyles);
const mockedTheme = createNewTheme(mockedThemeOverride);
export const vars = createNestedVars(mockedTheme);
